import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AddFundsComponent } from "./add-funds/add-funds.component";
import { CreidtlinereportComponent } from "./creidtlinereport/creidtlinereport.component";
import { ManageAdminFundsComponent } from "./manage-admin-funds/manage-admin-funds.component";
import { ManageRetailerFundsComponent } from "./manage-retailer-funds/manage-retailer-funds.component";

import { WalletComponent } from "./wallet.component";

const walletRoutes: Routes = [
  {
    path: "manage-admin-funds",
    component: ManageAdminFundsComponent,
  },
  {
    path: "credit-line-report",
    component: CreidtlinereportComponent,
  },
  {
    path: "add-money",
    component: AddFundsComponent,
  },
  {
    path: "manage-retailer-funds",
    component: ManageRetailerFundsComponent,
  },
  {
    path: "",
    redirectTo: "credit-line-report",
    pathMatch: "full",
  },
];

@NgModule({
  imports: [RouterModule.forChild(walletRoutes)],
  exports: [RouterModule],
})
export class WalletRoutingModule {}
